import { render, staticRenderFns } from "./PersonMergeDialog.vue?vue&type=template&id=598a8f90&scoped=true"
import script from "./PersonMergeDialog.vue?vue&type=script&lang=js"
export * from "./PersonMergeDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonMergeDialog.vue?vue&type=style&index=0&id=598a8f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598a8f90",
  null
  
)

export default component.exports